import { render, staticRenderFns } from "./OldBatch.vue?vue&type=template&id=1e6609c6&scoped=true&"
import script from "./OldBatch.vue?vue&type=script&lang=js&"
export * from "./OldBatch.vue?vue&type=script&lang=js&"
import style0 from "./OldBatch.vue?vue&type=style&index=0&id=1e6609c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6609c6",
  null
  
)

export default component.exports